import React, {useState, useEffect, useRef} from 'react';
import { Block, Icon, FormGroup, useForm, Map, CoordinatesModal, Dropzone, CoordinatesImportModal } from '../components';
import { useTranslation } from 'react-i18next';
import { Col, Row, DropdownButton, ButtonGroup, Dropdown } from 'react-bootstrap';
import ShowItem from "../ShowItem";
import useCustomTable from "../tables/useCustomTable";
import Table from "../tables/Table";
import BlockTable from "../BlockTable";
import {TableSearchRow} from "../tables/TableSearch";
import Pagination from "../tables/Pagination";

function CoordinatesFilter({coordinates = [], defaultRadius}) {
  const [tableRowHighlighted, setTableRowHighlighted] = useState(null);
  const [mapHovered, setMapHovered] = useState(null);
  const {t} = useTranslation();

  const columns = [{
      Header: 'Id',
      accessor: 'id',
    }, {
      Header: 'Key',
      accessor: 'key',
    }, {
      Header: 'Latitude',
      accessor: 'latitude',
    }, {
      Header: 'Longitude',
      accessor: 'longitude',
    }, {
      Header: 'Radius',
      accessor: 'radius',
      Cell: (cell) => String(cell.value || defaultRadius)
    }
  ]

  const tableOptions = {
    sortable: true,
    filterable: true,
    paginate: true
  }

  const customData = {
    type: 'FeatureCollection',
    properties: {type: 'point', interactive: true},
    features: coordinates.map((coord) => ({
      type: 'Feature',
      properties: {id: coord.id, radius: coord.radius || defaultRadius},
      geometry: {type: 'Point', coordinates: [parseFloat(coord.longitude), parseFloat(coord.latitude)]}
    }))
  }

  const handleMapHover = (feature) => {
    const index = feature ? coordinates.map( x => x.id ).indexOf(feature.value) : null
    setTableRowHighlighted(index >= 0 ? index : null)
  }

  const handleRowHover = (row) => {
    if (row) {
      setMapHovered(row.id)
    } else {
      setMapHovered(null)
    }
  }

  const heightStyle = {
    height: '507px',
    marginBottom: '30px'
  }

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tablePageLengthProps
  } = useCustomTable()

  return (
    <>
      <Block>
        <ShowItem label={t("zone.filterType")} value="Coordinates" />
        <ShowItem label={t("zone.coordinates.defaultRadius")} value={defaultRadius}/>
      </Block>
      <TableSearchRow {...tableSearchProps}/>
      <Row>
        <Col md={12} lg={6}>
          <BlockTable style={{marginBottom: "15px"}}>
            <Table
              small
              data={coordinates}
              columns={columns}
              hiddenColumns={['id']}
              {...tableOptions}
              {...tableProps}
              highlighted={tableRowHighlighted}
              onRowHover={handleRowHover}/>
          </BlockTable>
          <Pagination {...paginationProps}/>
        </Col>
        <Col md={12} lg={6} style={heightStyle}>
          <Map
            zoomLevel={4}
            pointData={customData}
            onHover={handleMapHover}
            disabled={true}
            hovered={{value: mapHovered, sources: ['fill', 'point']}}
          />
        </Col>
      </Row>
    </>
  )
}

export default CoordinatesFilter
